import { Record } from 'immutable';
import { pagingActions, fetchListActions } from './closed.actions';
import { publishedActions } from '../published';
import * as api from '../../api';
import { authActions } from '../../auth';
import { pagingDataUtilities } from '../../common';

export const ClosedMessagesState = Record({
  pagingData: pagingDataUtilities.PagingState({}),
  listState: api.ApiCallState({})
});

export const closedReducer = (initialState = new ClosedMessagesState(), action) => {

    var state = initialState.set('pagingData',
      pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

    const invalidateActions = pagingActions.allTypes
      .concat([authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS, publishedActions.closeMessageActions.success]);
    state = state.set('listState',
      api.apiCallReducer(state.get('listState'), action, fetchListActions, invalidateActions));

    return state;
  }
